import { SheetData } from './ProductData'
import { CoilsData } from './ProductData'
export const CopperImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/CopperImg/img9.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/CopperImg/img7.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/CopperImg/img3.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/CopperImg/img4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/CopperImg/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/CopperImg/img8.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  
  ]
  
  export const BrassImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/BrassImg/img1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/BrassImg/img2.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/BrassImg/img3.jpeg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/BrassImg/img4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/BrassImg/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/BrassImg/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  
  ]

  export const FlangeImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/FlangeImg/img7.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:2,
  //   img:require( '../Images/GalleryImg/FlangeImg/img2.jpg'),
  //   heading:"Chemical Processing",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:3,
    img:require( '../Images/GalleryImg/FlangeImg/img8.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/FlangeImg/img4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/FlangeImg/img10.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/FlangeImg/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:7,
    img:require( '../Images/GalleryImg/FlangeImg/img11.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:8,
  //   img:require( '../Images/GalleryImg/FlangeImg/img12.jpg'),
  //   heading:"Water Systems",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:9,
    img:require( '../Images/GalleryImg/FlangeImg/img13.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:10,
    img:require( '../Images/GalleryImg/FlangeImg/img14.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:11,
    img:require( '../Images/GalleryImg/FlangeImg/img15.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  ]

  export const NutBoltImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/NutBolt/img1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:2,
  //   img:require( '../Images/GalleryImg/NutBolt/img9.jpg'),
  //   heading:"Chemical Processing",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:3,
    img:require( '../Images/GalleryImg/NutBolt/img3.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  // {
  //   id:4,
  //   img:require( '../Images/GalleryImg/NutBolt/img4.jpg'),
  //   heading:"Power Generation",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:5,
    img:require( '../Images/GalleryImg/NutBolt/img5.png'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, 
  {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img6.jpeg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img10.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img11.webp'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img12.webp'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img13.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img14.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img15.webp'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img16.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img17.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img18.webp'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img19.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:6,
    img:require( '../Images/GalleryImg/NutBolt/img20.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  ]

  export const PipeImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/PipesImg/Img11.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/PipesImg/img2.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/PipesImg/img8.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/PipesImg/img4.png'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/PipesImg/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/PipesImg/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/PipesImg/img9.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/PipesImg/img10.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  
  ]

  export const AlboImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/PolishAlboImg/img1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/PolishAlboImg/img2.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/PolishAlboImg/img3.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/PolishAlboImg/img4.jpeg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/PolishAlboImg/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/PolishAlboImg/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  
  ]

  export const RodImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/RodImg/Bar8.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/RodImg/Bar10.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/RodImg/Bar9.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/RodImg/Bar4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/RodImg/Bar5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/RodImg/Bar6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:7,
    img:require( '../Images/GalleryImg/RodImg/Bar7.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  }, {
    id:8,
    img:require( '../Images/GalleryImg/RodImg/Bar2.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  {
    id:9,
    img:require( '../Images/GalleryImg/RodImg/Bar3.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  
  ]

  export const SqurImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/Squrpati/img1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:2,
  //   img:require( '../Images/GalleryImg/Squrpati/img2.jpg'),
  //   heading:"Chemical Processing",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  // {
  //   id:3,
  //   img:require( '../Images/GalleryImg/Squrpati/img3.jpg'),
  //   heading:"Electronics & Semi-Conductors",
  //   text:'All our products go through various quality checks from procurement to final delivery.',
    
  // },
  {
    id:4,
    img:require( '../Images/GalleryImg/Squrpati/img4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/Squrpati/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
   {
    id:6,
    img:require( '../Images/GalleryImg/Squrpati/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:6,
  //   img:require( '../Images/GalleryImg/Squrpati/img8.jpg'),
  //   heading:"Water Systems",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:6,
    img:require( '../Images/GalleryImg/Squrpati/img9.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/Squrpati/img10.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  ]
  export const WireImgData=[
  

   {
    id:6,
    img:require( '../Images/GalleryImg/WireImg/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/WireImg/Wire.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
 
  // {
  //   id:6,
  //   img:require( '../Images/GalleryImg/WireImg/Wire2.jpg'),
  //   heading:"Water Systems",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  // {
  //   id:6,
  //   img:require( '../Images/GalleryImg/WireImg/Wire3.jpg'),
  //   heading:"Water Systems",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  // {
  //   id:6,
  //   img:require( '../Images/GalleryImg/WireImg/Wire4.jpg'),
  //   heading:"Water Systems",
  //   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  // },
  {
    id:6,
    img:require( '../Images/GalleryImg/WireImg/Wire5.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  
  ]

  export const HexBarImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/RodImg/img2.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/RodImg/img10.png'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/RodImg/img4.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/RodImg/img9.webp'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/RodImg/img7.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/RodImg/img8.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
 
  
  ]

  export const SeamlessPipeImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/SeamlessPipe/img1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/SeamlessPipe/img2.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/SeamlessPipe/img3.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/SeamlessPipe/img4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:5,
    img:require( '../Images/GalleryImg/SeamlessPipe/img5.jpg'),
    heading:"Pulp & Paper Mills",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }, {
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img7.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img8.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img9.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img10.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img11.jpeg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img12.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img13.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },{
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/img14.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  
  ]
  export const WeldedPipeImgData=[
    {
    id:1,
    img:require( '../Images/GalleryImg/SeamlessPipe/Wimg1.jpg'),
    heading:"Air Pollution",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require( '../Images/GalleryImg/SeamlessPipe/Wimg2.jpg'),
    heading:"Chemical Processing",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require( '../Images/GalleryImg/SeamlessPipe/Wimg3.jpg'),
    heading:"Electronics & Semi-Conductors",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require( '../Images/GalleryImg/SeamlessPipe/Wimg4.jpg'),
    heading:"Power Generation",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  // {
  //   id:5,
  //   img:require( '../Images/GalleryImg/SeamlessPipe/Wimg5.jpg'),
  //   heading:"Pulp & Paper Mills",
  //   text:'All our products go through various quality checks from procurement to final delivery.',
    
  // }, 
  {
    id:6,
    img:require( '../Images/GalleryImg/SeamlessPipe/Wimg6.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
]

export const TubesPipeImgData=[
  {
  id:1,
  img:require( '../Images/GalleryImg/tubesimg/img1.jpg'),
  heading:"Air Pollution",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/GalleryImg/tubesimg/img2.jpeg'),
  heading:"Chemical Processing",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/GalleryImg/tubesimg/img3.jpeg'),
  heading:"Electronics & Semi-Conductors",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/GalleryImg/tubesimg/img4.jpeg'),
  heading:"Power Generation",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/GalleryImg/tubesimg/img5.jpeg'),
  heading:"Pulp & Paper Mills",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/GalleryImg/tubesimg/img6.jpeg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:4,
  img:require( '../Images/GalleryImg/tubesimg/img7.jpeg'),
  heading:"Power Generation",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/GalleryImg/tubesimg/img8.jpeg'),
  heading:"Pulp & Paper Mills",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/GalleryImg/tubesimg/img9.jpeg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
]
export const FlatImgData=[
  {
  id:1,
  img:require( '../Images/GalleryImg/Squrpati/Fimg1.jpg'),
  heading:"Air Pollution",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/GalleryImg/Squrpati/Fimg2.jpg'),
  heading:"Chemical Processing",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/GalleryImg/Squrpati/Fimg3.jpg'),
  heading:"Electronics & Semi-Conductors",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/GalleryImg/Squrpati/Fimg4.jpg'),
  heading:"Power Generation",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/GalleryImg/Squrpati/Fimg5.png'),
  heading:"Pulp & Paper Mills",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/GalleryImg/Squrpati/Fimg6.jpg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
]

export const PipeFitingImgData=[
  {
    id:6,
    img:require( '../Images/GalleryImg/PipeFitings/img17.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/PipeFitings/img18.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/PipeFitings/img19.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/PipeFitings/img20.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
  id:1,
  img:require( '../Images/GalleryImg/PipeFitings/img1.png'),
  heading:"Air Pollution",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/GalleryImg/PipeFitings/img2.jpg'),
  heading:"Chemical Processing",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
// {
//   id:3,
//   img:require( '../Images/GalleryImg/PipeFitings/img3.webp'),
//   heading:"Electronics & Semi-Conductors",
//   text:'All our products go through various quality checks from procurement to final delivery.',
  
// },
// {
//   id:4,
//   img:require( '../Images/GalleryImg/PipeFitings/img4.png'),
//   heading:"Power Generation",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:5,
//   img:require( '../Images/GalleryImg/PipeFitings/img5.jpg'),
//   heading:"Pulp & Paper Mills",
//   text:'All our products go through various quality checks from procurement to final delivery.',
  
// }, {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img6.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img7.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img8.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img9.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img10.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img11.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img12.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img13.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img14.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img15.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },
// {
//   id:6,
//   img:require( '../Images/GalleryImg/PipeFitings/img16.jpg'),
//   heading:"Water Systems",
//   text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
// },

]


export const ElectrodWireImgData=[
  {
    id:6,
    img:require( '../Images/GalleryImg/ElectrodWire/img1.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/ElectrodWire/img2.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/ElectrodWire/img3.jpg'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:6,
    img:require( '../Images/GalleryImg/ElectrodWire/img4.png'),
    heading:"Water Systems",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
  id:1,
  img:require( '../Images/GalleryImg/ElectrodWire/img5.jpg'),
  heading:"Air Pollution",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/GalleryImg/ElectrodWire/img6.jpeg'),
  heading:"Chemical Processing",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/GalleryImg/ElectrodWire/img7.jpeg'),
  heading:"Electronics & Semi-Conductors",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/GalleryImg/ElectrodWire/img8.jpg'),
  heading:"Power Generation",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/GalleryImg/ElectrodWire/img9.jpg'),
  heading:"Pulp & Paper Mills",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/GalleryImg/ElectrodWire/img10.jpg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:6,
  img:require( '../Images/GalleryImg/ElectrodWire/img11.jpg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},{
  id:6,
  img:require( '../Images/GalleryImg/ElectrodWire/img12.jpg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
]
export const SheetgalleryData=[
  {
  id:1,
  img:require('../Images/SheetImg/Sheet1.jpg'),
 
},
{
  id:2,
  img:require('../Images/SheetImg/Sheet2.jpg'),

},
{
  id:3,
  img:require('../Images/SheetImg/Sheet11.jpeg'),
 
  
},
// {
//   id:4,
//   img:require('../Images/SheetImg/Sheet4.jpg'),

// },
{
  id:6,
  img:require('../Images/SheetImg/Sheet5.jpg'),
 
},

// {
//   id:8,
//   img:require('../Images/SheetImg/Sheet6.jpg'),


// },
// {
//   id:9,
//   img:require('../Images/SheetImg/Sheet7.jpg'),
  
// },
{
  id:10,
  img:require('../Images/SheetImg/Sheet8.jpg'),
  
  
},
// {
//   id:5,
//   img:require('../Images/SheetImg/Sheet9.jpg'),

  
// }
{
  id:12,
  img:require('../Images/SheetImg/Sheet10.jpg'),

},
]

export const CoilsgalleryData=[
  {
  id:1,
  img:require("../Images/CoilsImg/Coils1.jpg"),
  },
// {
//   id:2,
//   img:require("../Images/CoilsImg/Coils2.jpg"),

// },
{
  id:3,
  img:require("../Images/CoilsImg/img1.jpg"),

  
},
// {
//   id:4,
//   img:require("../Images/CoilsImg/Coils4.jpg"),

  
// },
// {
//   id:6,
//   img:require("../Images/CoilsImg/Coils5.jpg"),

  
// },

{
  id:8,
  img:require("../Images/CoilsImg/Coils6.jpg"),

},
{
  id:9,
  img:require("../Images/CoilsImg/img2.jpg"),

  
},
// {
//   id:10,
//   img:require("../Images/CoilsImg/Coils8.jpg"),

  
// },
{
  id:11,
  img:require("../Images/CoilsImg/Coils9.jpg"),

  
},
{
  id:12,
  img:require("../Images/CoilsImg/img5.jpeg"),

  
},
]







  export const GallerytabData=[{
   title:"Sheet & Plate",
   Data:SheetgalleryData
  },
  {
    title:"Coils & Stirps",
    Data:CoilsgalleryData,

 
   },{
    title:"Round Bar",
    Data:RodImgData,

 
   }
   ,{
    title:"Channel & Angle",
    Data:SqurImgData,

 
   },
   {
    title:"Wires",
    Data:WireImgData,

 
   },
   {
    title:"Flange",
    Data:FlangeImgData,

 
   }
   ,
   {
    title:"Nut & Bolt",
    Data:NutBoltImgData,
  
 
   },{
    title:"Polish Pipes",
    Data:PipeImgData,
   },{
    title:"Seamless Pipe",
    Data:SeamlessPipeImgData,
  
 
   }
   ,{
    title:"Hexbar & Squrebar",
    Data:HexBarImgData,
  
 
   }
   ,{
    title:"Welded Pipe",
    Data:WeldedPipeImgData,
  
 
   }
   ,{
    title:"Tubes Pipe",
    Data:TubesPipeImgData,
  
 
   }
   ,{
    title:"Pipe Fitting",
    Data:PipeFitingImgData,
  
 
   }
   ,{
    title:"Valves & Dairy Fitting",
    Data:AlboImgData,
  
 
   }
   ,{
    title:"Flat",
    Data:FlatImgData,
  
 
   }

   ,{
    title:"Electrode Wire",
    Data:ElectrodWireImgData,

   }
   ,{
    title:"Copper",
    Data:CopperImgData,
  
 
   }
   ,{
    title:"Brass",
    Data:BrassImgData,
  
 
   }

]
